import React from "react";
import { Box, Typography, useTheme } from "@mui/material";
import { Icon } from "@iconify/react";
import { useTranslation } from "react-i18next";
export const StatusIndicator = ({ variant, label, sx, }) => {
    const theme = useTheme();
    const { t } = useTranslation("common");
    // Get icon, color, and label based on variant using switch-case
    const getStatusConfig = () => {
        switch (variant) {
            case "active":
                return {
                    iconName: "material-symbols-light:circle",
                    color: theme.palette.primary.dark,
                    defaultLabel: t("status.active"),
                    iconSize: 12,
                };
            case "inactive":
                return {
                    iconName: "ci:warning",
                    color: theme.palette.error.main,
                    defaultLabel: t("status.inactive"),
                    iconSize: 16,
                };
            case "unacknowledged":
                return {
                    iconName: "ci:warning",
                    color: theme.palette.error.main,
                    defaultLabel: t("status.unacknowledged"),
                    iconSize: 16,
                };
            case "acknowledged":
                return {
                    iconName: "carbon:checkmark-outline",
                    color: theme.palette.success.main,
                    defaultLabel: t("status.acknowledged"),
                    iconSize: 16,
                };
            case "handled":
                return {
                    iconName: "carbon:checkmark-outline",
                    color: theme.palette.success.main,
                    defaultLabel: t("status.handled"),
                    iconSize: 16,
                };
            case "unhandled":
                return {
                    iconName: "ci:warning",
                    color: theme.palette.error.main,
                    defaultLabel: t("status.unhandled"),
                    iconSize: 16,
                };
            default:
                return {
                    iconName: "ci:warning",
                    color: theme.palette.error.main,
                    defaultLabel: t("status.unknown", "Unknown"),
                    iconSize: 16,
                };
        }
    };
    const statusConfig = getStatusConfig();
    const displayLabel = label || statusConfig.defaultLabel;
    return (React.createElement(Box, { sx: Object.assign({ display: "inline-flex", alignItems: "center", justifyContent: "start", gap: 0.5, borderRadius: 1 }, sx) },
        React.createElement(Icon, { icon: statusConfig.iconName, width: statusConfig.iconSize, height: statusConfig.iconSize, color: statusConfig.color, style: { color: statusConfig.color } }),
        React.createElement(Typography, { variant: "body2", style: {
                color: statusConfig.color,
                fontSize: "13px",
                fontWeight: 500,
                lineHeight: 1,
            } }, displayLabel)));
};
export default StatusIndicator;
